import { FormControlLabel, Switch } from "@mui/material";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useUserPreferencesStore } from "src/lib/store";


const PositiveModeSwap = () => {
  const { i18n, t } = useTranslation();
  const [positiveMode, setPositiveMode] = useUserPreferencesStore(state => [state.positiveMode, state.setPositiveMode])

  useEffect(()=> {
    document.documentElement.dataset.positiveMode = String(positiveMode)
    // if(positiveMode){
    //   dayjs.updateLocale('fr', { "labels": {"event" : "hahaha"}})
    // }
    // else
    //   dayjs.locale(i18n.language) 
  }, [positiveMode])
  return (
    <FormControlLabel className="px-2" control={<Switch checked={positiveMode} onChange={(event, checked) => setPositiveMode(checked)} size="small"/>} label={t("labels.positiveMode")} />
  );
}
export default PositiveModeSwap
